import React, { useEffect, useState, useCallback } from "react";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import Bunexe_service from "../../../Bunexe_service";

const AfficheNote = ({ une_note, utilisateur, prog }) => {
  const { Suffixe, Symbolique, Note1, Note2, Note3 } = une_note;

  const [not1, setNot1] = useState(Note1 || "");
  const [not2, setNot2] = useState(Note2 || "");
  const [not3, setNot3] = useState(Note3 || "");
  const [troisieme, setTroisieme] = useState(false);

  const url_ = Bunexe_service.url;

  const setFocus = (champId) => {
    const element = document.getElementById(champId);
    if (element) element.focus();
  };

  const updateSymbolique = useCallback(
    async (symbolique, numero_correction, note) => {
      if (!utilisateur || utilisateur === "NULL") {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Il semble que vous devez vous reconnecter à la plateforme bunexe.work",
          footer: "<h6>Prière de vous reconnecter à la plateforme</h6>",
        });
        return;
      }

      const formData = {
        symbolique,
        numero_correction,
        note_: note,
        utilisateur,
        prog,
      };

      try {
        const response = await fetch(`${url_}/saisie_notes_bac/ajouter_note`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData),
        });

        const data = await response.json();
        if (data.msg !== "OK") {
          toast.error("Erreur de mise à jour de la note", {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      } catch (error) {
        console.error("Erreur lors de la mise à jour de la note :", error);
        toast.error("Erreur de connexion au serveur", {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    },
    [utilisateur, prog, url_],
  );

  const validateAndUpdateNote = (
    valeur,
    initialNote,
    numeroCorrection,
    fieldId,
  ) => {
    const valTrim = String(valeur).trim();

    if (valTrim.length < 3) return;

    const valNum = parseInt(valTrim, 10);

    if (isNaN(valNum) || valNum < 2 || valNum > 100) {
      toast.error("La note doit être comprise entre 002 et 100", {
        position: toast.POSITION.TOP_RIGHT,
      });
      setFocus(fieldId);
      return;
    }

    if (valNum % 2 !== 0) {
      toast.error("La note doit être paire", {
        position: toast.POSITION.TOP_RIGHT,
      });
      setFocus(fieldId);
      return;
    }

    if (valTrim !== String(initialNote)) {
      updateSymbolique(Symbolique, numeroCorrection, valTrim);
    }
  };

  useEffect(() => {
    const n1 = parseInt(not1, 10);
    const n2 = parseInt(not2, 10);

    if (
      !isNaN(n1) &&
      !isNaN(n2) &&
      n1 >= 2 &&
      n2 >= 2 &&
      Math.abs(n1 - n2) >= 12
    ) {
      setTroisieme(true);
    } else {
      setTroisieme(false);
    }
  }, [not1, not2, une_note]);

  const n1 = parseInt(not1, 10);
  const n2 = parseInt(not2, 10);
  const n3 = parseInt(not3, 10);

  const showNote3 =
    (!isNaN(n3) && n3 >= 2) ||
    (!isNaN(n1) &&
      !isNaN(n2) &&
      n1 >= 2 &&
      n2 >= 2 &&
      Math.abs(n1 - n2) >= 16) ||
    (String(not1).trim() === "" && String(not2).trim() === "");

  return (
    <div>
      <div className="row p-0 align-items-center">
        <div className="col-xs-3 col-md-5">
          <p
            className="mb-0"
            style={{
              fontWeight: "bolder",
              fontSize: "14px",
              letterSpacing: "2px",
            }}
          >
            <span style={{ fontSize: "16px" }} className="ml-1">
              ({Suffixe})
            </span>
            <span className={troisieme ? "text-danger" : "text-default"}>
              {` ${Symbolique}`}
            </span>
          </p>
        </div>

        {/* Note 1 */}
        <div className="col-xs-3 col-md-2">
          <input
            type="text"
            className="form-control"
            id={`${Symbolique}-n1`}
            name={`${Symbolique}-n1`}
            value={not1}
            placeholder="Note 1"
            onChange={(e) => setNot1(e.target.value)}
            onBlur={(e) =>
              validateAndUpdateNote(
                e.target.value,
                Note1,
                "1",
                `${Symbolique}-n1`,
              )
            }
          />
        </div>

        {/* Note 2 */}
        <div className="col-xs-3 col-md-2">
          <input
            type="text"
            className="form-control"
            id={`${Symbolique}-n2`}
            name={`${Symbolique}-n2`}
            value={not2}
            placeholder="Note 2"
            onChange={(e) => setNot2(e.target.value)}
            onBlur={(e) =>
              validateAndUpdateNote(
                e.target.value,
                Note2,
                "2",
                `${Symbolique}-n2`,
              )
            }
          />
        </div>

        {/* Note 3 */}
        {showNote3 && (
          <div className="col-xs-3 col-md-2">
            <input
              type="text"
              className="form-control"
              id={`${Symbolique}-n3`}
              name={`${Symbolique}-n3`}
              value={not3}
              placeholder="Note 3"
              onChange={(e) => setNot3(e.target.value)}
              onBlur={(e) =>
                validateAndUpdateNote(
                  e.target.value,
                  Note3,
                  "3",
                  `${Symbolique}-n3`,
                )
              }
            />
          </div>
        )}
      </div>
      <hr className="my-1" />
    </div>
  );
};

export default AfficheNote;
